module.exports = __webpack_public_path__ + "img/product25ap.69da830a.png";